import React, { memo, useState, useCallback } from 'react';
import Map from '@/components/Map';
import Heading from '@/shared/Heading';
import OrderListCard from '@/shared/crisp/OrderListCard';
import PageLayout from '@/components/Layouts/PageLayout';
import Container from '@/shared/Container';
import useOnMount from '@/hooks/useOnMount';
import { getOrderList } from '@/actions/ecom/order';
import useTriggerRequest from '@/hooks/useTriggerRequest';
import ContentLoader from 'react-content-loader';
import dlv from 'dlv';
import PromoBanner from '@/components/PromoBanner';

const Loader = (props: any) => (
  <ContentLoader
    speed={2}
    width={320}
    height={500}
    viewBox="0 0 320 500"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    className="w-full sm:w-fit h-fit m-auto"
    {...props}
  >
    <rect x="0" y="0" rx="5" ry="5" width="320" height="100" />
    <rect x="0" y="120" rx="5" ry="5" width="320" height="100" />
    <rect x="0" y="240" rx="5" ry="5" width="320" height="100" />
    <rect x="0" y="360" rx="5" ry="5" width="320" height="100" />
  </ContentLoader>
);

const OrdersPage = () => {
  const [loading, setLoading] = useState(true);
  const fetch = (...args: any) => getOrderList.apply(null, args);
  const orders = useTriggerRequest({ fetch });
  useOnMount(async () => {
    await orders.promisifyTrigger({
      page: 0,
      size: 100,
      sortBy: 'createdOn',
      sortOrder: 'DESC',
      orderItemTypes: ['product'],
    });
    setLoading(false);
  });

  const renderOrder = useCallback((item: any) => {
    const { name, img } = dlv(item, 'orderItems.0.properties', {});

    const { userOrderId, id, createdOn, status, orderItems } = item;

    return (
      <OrderListCard
        key={id}
        id={id}
        userOrderId={userOrderId}
        name={name}
        img={img}
        orderItems={orderItems}
        createdOn={createdOn}
        status={status}
      />
    );
  }, []);

  const orderList = dlv(orders, 'data.data.data', []);

  const renderOrders = () => {
    if (orderList.length > 0) {
      return (
        <Map className="flex flex-col gap-s4 md:gap-s7" list={orderList} render={renderOrder} />
      );
    }
    return 'Orders not found!';
  };

  return (
    <PageLayout mainClassName="font-primary pb-16">
      <Container>
        <Heading level={2} className="text-h-2 md:text-hd-2 mb-s7 mt-s6 md:mt-s7">
          My orders
        </Heading>
        <PromoBanner className="my-s4" />
        {loading ? <Loader /> : renderOrders()}
      </Container>
    </PageLayout>
  );
};

export default memo(OrdersPage);
